/* toast */
const Toast = async (config) => {
  var ToastAlertElm = document.querySelector("#ToastAlert");
  if (!ToastAlertElm) return;
  ToastAlertElm.style.zIndex = `99999999999999 !important`;
  ToastAlertElm.style.textAlign = "center";
  ToastAlertElm.querySelector(".toast-msg").innerHTML = config.message;
  let instance = window.Toast.getInstance(ToastAlertElm);
  if (!instance) {
    return alert(config.message);
  }

  instance.update({
    position: config?.position || "top-center",
    autohide: true,
    color: config?.color || (config.status == "success" ? "success" : "danger"),
    delay: config.delay ? config.delay : 1500,
  });
  instance.show();
};

const hideToast = () => {
  var ToastAlertElm = document.querySelector("#ToastAlert");
  if (!ToastAlertElm) return;
  let instance = window.Toast.getInstance(ToastAlertElm);
  if (!instance) return;
  instance.hide();
};

const showErrorMessages = (modal, messages, duration = 5000, html_temp = null) => {
  duration = isNaN(duration) ? 5000 : duration;
  let _errorModalTimer = null;
  try {
    if (!modal) throw new Error("modal not found");
    const msgs = Array.isArray(messages) ? messages : [messages];
    const html = msgs.map((m) => `<p class="text-danger mb-0"><i class="fas fa-exclamation-circle me-1"></i>${m}</p>`).join("");
    modal._element.querySelector(".modal-body").innerHTML = html_temp ?? html;
    closeOpenModals();
    modal.show();

    clearTimeout(_errorModalTimer);
    _errorModalTimer = setTimeout(() => {
      if (modal) {
        modal.hide();
      }
    }, duration);
  } catch (error) {
    Toast({
      status: "error",
      message: messages,
      delay: duration,
    });
  }
};

const closeOpenModals = () => {
  const openModal = document.querySelector(".modal.show"); // or use specific selector
  if (openModal) {
    const closeBtn = openModal.querySelector(".modal-close, .btn-close");
    if (closeBtn) {
      closeBtn.click();
    } else {
      // fallback if no close button
      openModal.classList.remove("show");
      openModal.setAttribute("aria-hidden", "true");
      openModal.style.display = "none";
      document.body.classList.remove("modal-open");
      document.body.style = "";
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) backdrop.remove();
    }
  }
};

const showAlert = ({ message, delay = 3000, status = "success", container }) => {
  if (!container || !(container instanceof HTMLElement)) {
    console.error("Invalid container element provided.");
    return;
  }

  // Remove existing alert if present
  const existingAlert = container.querySelector(".alert");
  if (existingAlert) {
    existingAlert.remove();
  }

  // Create new alert div
  const alertDiv = document.createElement("div");
  alertDiv.setAttribute("data-mdb-alert-init", "");
  alertDiv.classList.add("alert", "d-flex", "align-items-center");
  alertDiv.setAttribute("role", "alert");

  // Set alert color based on status
  const alertColor = status === "success" ? "primary" : "danger";
  alertDiv.setAttribute("data-mdb-color", alertColor);

  // Set message content
  alertDiv.innerHTML = `
    <i class="fa-solid fa-circle-info text-${alertColor} me-2"></i>
    <p class="m-0 p-0 text-${alertColor}">${message}</p>
  `;

  // Append to container
  container.appendChild(alertDiv);

  // Remove alert after delay
  setTimeout(() => {
    alertDiv.remove();
  }, delay);
};

/* slide function */
const slideToElement = (container, fromElement, toElement, direction = "left") => {
  const hiddenClass = direction === "left" ? "hidden-left" : "hidden-right";

  // Remove active class from the current element
  fromElement.classList.remove("active");
  fromElement.classList.add(hiddenClass);

  // Add active class to the target element
  toElement.classList.remove("hidden-left", "hidden-right");
  toElement.classList.add("active");

  // Adjust container height to match the new element (optional)
  if (container) {
    container.style.height = `${toElement.offsetHeight}px`;
  }
};

const formatDate = (date, format) => {
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  const dateParts = new Intl.DateTimeFormat("en-US", options).formatToParts(date);
  const dateMap = {};

  dateParts.forEach(({ type, value }) => {
    dateMap[type] = value;
  });

  return format
    .replace("YYYY", dateMap.year)
    .replace("YY", dateMap.year.slice(-2))
    .replace("MM", dateMap.month)
    .replace("DD", dateMap.day)
    .replace("HH", dateMap.hour)
    .replace("mm", dateMap.minute)
    .replace("ss", dateMap.second)
    .replace("d", String(parseInt(dateMap.day, 10)).padStart(2, "0"))
    .replace("m", String(parseInt(dateMap.month, 10)).padStart(2, "0"))
    .replace("Y", dateMap.year);
};

const initDate = (days = 0, format = "DD/MM/YYYY") => {
  const date = new Date();
  date.setDate(date.getDate() + days);

  let day = date.getDate();
  let month = date.getMonth() + 1;
  const year = date.getFullYear();

  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;

  return format.replace("DD", day).replace("MM", month).replace("YYYY", year).replace("YY", String(year).slice(-2));
};

const FormatDate = (days = 0, format = "DD/MM/YYYY") => {
  const date = new Date();
  date.setDate(date.getDate() + days);

  let day = date.getDate();
  let month = date.getMonth() + 1;
  const year = date.getFullYear();

  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;

  return format.replace("DD", day).replace("MM", month).replace("YYYY", year).replace("YY", String(year).slice(-2));
};

/**
 * Focuses the given input element with error handling.
 * @param {HTMLElement} inputElement - The input element to focus.
 */
const focusInput = (inputElement) => {
  if (inputElement instanceof HTMLElement && typeof inputElement.focus === "function") {
    inputElement.scrollIntoView({ behavior: "smooth", block: "center" });
    setTimeout(() => {
      inputElement.focus();
    }, 100);
  }
};

/** Blur focused field to dismiss on-screen keyboard (mobile). */
const closeKeyboard = (inputElement) => {
  if (inputElement instanceof HTMLElement && typeof inputElement.blur === "function") {
    inputElement.blur();
  }
};

/**
 * @param {HTMLElement} element
 * @param {"start"|"center"|"end"|"nearest"} [block]
 */
const scrollToElement = (element, block = "center") => {
  if (element instanceof HTMLElement) {
    element.scrollIntoView({ behavior: "smooth", block });
  }
};

const initAutocomplete = (element, dataArray, key, autocomplete) => {
  if (!element) {
    return;
  }
  // Filter function that handles both regular arrays and arrays of objects
  const dataFilter = (value) => {
    return dataArray.filter((item) => {
      const itemValue = typeof item === "object" && key ? item[key] : item;
      return itemValue && itemValue.toLowerCase().startsWith(value.toLowerCase());
    });
  };
  if (autocomplete) {
    autocomplete.dispose();
  }
  const instance = new Autocomplete(element, {
    filter: dataFilter,
    displayValue: (value) => (typeof value === "object" && key ? value[key] : value),
    threshold: 2,
    ...AUTOCOMPLETE_OPTIONS,
  });
  return instance;
};

const resetForm = (form) => {
  if (!form) return;
  form.querySelector("form").reset();
  form.querySelectorAll("input").forEach((input) => {
    input.classList.remove("is-valid");
    input.value = "";
  });
  form.querySelectorAll(".select-clear-btn").forEach((btn) => {
    btn.click();
  });
};

const resetTabs = (formElm) => {
  const allTabLinks = formElm.querySelectorAll(".nav-link");
  const allTabPanes = formElm.querySelectorAll(".tab-pane");

  // Remove active class and danger class from all tabs
  allTabLinks.forEach((tabLink) => {
    tabLink.classList.remove("active", "text-danger");
  });

  allTabPanes.forEach((tabPane) => {
    tabPane.classList.remove("active", "show");
  });

  if (allTabLinks.length > 0 && allTabPanes.length > 0) {
    allTabLinks[0].classList.add("active");
    allTabPanes[0].classList.add("active", "show");
  }
};

const initBasicTabs = (containerSelector) => {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const tabs = container.querySelectorAll('[role="tab"]');
  const tabPanels = container.querySelectorAll('[role="tabpanel"]');

  tabs.forEach((tab) => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      // הסר אקטיב מכל הטאבים
      tabs.forEach((t) => {
        t.classList.remove("active");
        t.setAttribute("aria-selected", "false");
      });

      // הסתר את כל הפאנלים
      tabPanels.forEach((panel) => {
        panel.classList.remove("show", "active");
      });

      // הפעל את הטאב הנבחר
      this.classList.add("active");
      this.setAttribute("aria-selected", "true");

      const targetId = this.getAttribute("href");
      const targetPane = container.querySelector(targetId);
      if (targetPane) {
        targetPane.classList.add("show", "active");
      }
    });
  });
};

const updateTabHeadersWithValidationStatus = (formElm) => {
  const allTabLinks = formElm.querySelectorAll(".nav-link");
  allTabLinks.forEach((tabLink) => {
    tabLink.classList.remove("text-danger");
  });

  const invalidElements = formElm.querySelectorAll(":invalid");
  if (invalidElements.length > 0) {
    invalidElements.forEach((invalidElement) => {
      const closestTab = invalidElement.closest(".tab-pane");
      if (closestTab) {
        const tabId = closestTab.id;
        const tabLink = document.querySelector(`[href="#${tabId}"]`);
        if (tabLink) {
          tabLink.classList.add("text-danger");
        }
      }
    });
  }
};

/**
 * getRedirectUrl
 * Reads the "redirect" parameter from the current URL and builds the final redirect path.
 *
 * @param {string} default_path - fallback path if no redirect param exists
 * @returns {string} - full absolute redirect URL
 */
const getRedirectUrl = (default_path = "") => {
  const urlParams = new URLSearchParams(window.location.search);
  const redirectParam = urlParams.get("redirect");
  const target = redirectParam || default_path;

  if (!target) {
    return "";
  }

  if (/^https?:\/\//i.test(target)) {
    return decodeURIComponent(target);
  }

  const cleanTarget = decodeURIComponent(target).replace(SITE_URL, "").replace(/^\/+/, "");
  return `${SITE_URL}${cleanTarget}`;
};

class Calculator {
  PriceBeforeVat(price, callback) {
    var vat = (Number(price) * (Number(VAT) / 100)).toFixed(2);
    var totalPrice = (Number(price) + Number(vat)).toFixed(2);
    var result = {
      price: Number(price).toFixed(2),
      vat: vat,
      totalPrice: totalPrice,
    };
    callback(result);
  }
  PriceIncludeVat(totalPrice, callback) {
    var vat = (Number(totalPrice) - (Number(totalPrice) * 100) / (100 + VAT)).toFixed(2);
    var price = (Number(totalPrice) - Number(vat)).toFixed(2);
    var result = {
      price: price,
      vat: vat,
      totalPrice: Number(totalPrice).toFixed(2),
    };
    callback(result);
  }

  CalculatePriceWithVat(priceWithoutVat, decimalPlaces = 2) {
    // Calculate the VAT amount
    console.log("VAT:", VAT);
    const vatAmount = (priceWithoutVat * VAT) / 100;

    // Calculate the total price including VAT
    const totalPrice = priceWithoutVat + vatAmount;

    return {
      total_price: this.FormatCurrency(totalPrice, decimalPlaces), // Total price including VAT
      price_without_vat: this.FormatCurrency(priceWithoutVat, decimalPlaces), // Price without VAT
      vat_amount: this.FormatCurrency(vatAmount, decimalPlaces), // VAT amount
    };
  }

  FormatCurrency(amount, decimalPlaces = 2) {
    return amount.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
const $Calculator = new Calculator();
